import { schedulesList } from "../schedules";
import { PACKAGE_TYPES, PACKAGE_LABELS } from "../packageTypes";

export const calculateSchedulePricing = (schedules = [], voucherValid) => {
  let originalTotal = 0;
  const priceSummaryUI = [];
  const normalizedSchedules = [];

  schedules.forEach((schedule, index) => {
    if (!schedule?.packageType) return;

    const { packageType, cities = [] } = schedule;
    const cityCount = cities.length;
    const scheduleName = schedulesList[index];

    let price = 0;

    if (packageType === PACKAGE_TYPES.REGULAR && cityCount > 0) {
      price = cityCount >= 8 ? 10880 : cityCount * 1700;
    }

    if (packageType === PACKAGE_TYPES.TRIAL && cityCount > 0) {
      price = cityCount >= 8 ? 7680 : cityCount * 1200;
    }

    if (packageType === PACKAGE_TYPES.PLATINUM) {
      price = 15000;
    }

    if (!price) return;

    originalTotal += price;

    priceSummaryUI.push({
      scheduleName,
      packageType: PACKAGE_LABELS[packageType],
      cityCount: packageType === PACKAGE_TYPES.PLATINUM ? "All Cities" : `${cityCount} Cities`,
      cities,
      price
    });

    normalizedSchedules.push({
      scheduleName,
      packageType,
      cities,
      cityCount,
      price
    });
  });

  return {
    originalTotal,
    discountedTotal: voucherValid ? originalTotal * 0.5 : originalTotal,
    priceSummaryUI,
    normalizedSchedules
  };
};